import { ExternalLink } from "lucide-react";
import { PARTNER_LINK } from "@/lib/constants";

const FinalCTASection = () => (
  <section className="py-10 md:py-16">
    <div className="container">
      <div className="mx-auto max-w-2xl rounded-2xl border border-primary/20 bg-card p-6 text-center sm:p-8 md:p-10">
        <h2 className="font-display text-lg font-bold text-foreground sm:text-xl md:text-2xl">
          heilys im offiziellen Shop ansehen
        </h2>
        <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">
          Über den Partnerlink gelangst du direkt zum vollständigen heilys Sortiment – und unterstützt
          gleichzeitig diese unabhängige Informationsseite.
        </p>

        <div className="mt-6 flex justify-center">
          <a
            href={PARTNER_LINK}
            target="_blank"
            rel="sponsored noopener noreferrer"
            onClick={() => window.lh?.trackAffiliate({ source: "final_cta" })}
            className="inline-flex items-center justify-center gap-1.5 rounded-lg bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground shadow-lg shadow-primary/25 transition-all hover:shadow-xl hover:shadow-primary/30 hover:brightness-110"
          >
            Zum offiziellen heilys Shop
            <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
          </a>
        </div>

        <p className="mt-4 text-xs text-muted-foreground">
          Partnerlink · Der Preis für dich bleibt unverändert.
        </p>
      </div>
    </div>
  </section>
);

export default FinalCTASection;
